import React from 'react';
interface ContentSectionProps {
  title: string;
  content: ReactNode;
  bgColor?: string;
  titleClass?: string;
  containerClass?: string;
}
export function ContentSection({
  title,
  content,
  bgColor = 'bg-white',
  titleClass = 'text-3xl md:text-4xl text-gray-900',
  containerClass = ''
}: ContentSectionProps) {
  return <section className={`w-full py-6 ${bgColor} rounded-lg my-5 ${containerClass}`} data-id="element-59">
      <div className={`mx-auto ${containerClass || 'max-w-3xl'}`} data-id="element-60">
        <h2 className={`font-bold mb-6 leading-tight text-center ${titleClass}`} data-id="element-61">
          {title}
        </h2>
        <div className="text-xl font-medium" data-id="element-62">{content}</div>
      </div>
    </section>;
}